'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeriesCombinations = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getSeriesCombinations = exports.getSeriesCombinations = function getSeriesCombinations(combinations, oneValuesDimensions) {
  var indexedValues = R.reduce(function (acc, dim) {
    var value = R.head(dim.values);
    return R.assoc(dim.id, value, acc);
  }, {}, oneValuesDimensions);
  return R.reduce(function (acc, comb) {
    if (!R.prop('series', comb)) {
      return acc;
    }
    var fixedDimValues = R.pick(comb.concepts, indexedValues);
    return R.append((0, _extends3.default)({}, comb, {
      fixedDimValues: fixedDimValues
    }), acc);
  }, [], combinations);
};